/* global axios */
import ApiClient from './ApiClient';

class AttributeAPI extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }

  getAttributesByModel() {
    return axios.get(this.url);
  }

  // Ids na ordem em que a lista ficou depois do arrastar.
  reorder(ids) {
    return axios.post(`${this.url}/reorder`, { ids });
  }
}

export default new AttributeAPI();
